<template>
  <div>
    <div :style="titleStyle"
         style="display: flex; flex-direction: column; justify-content: center; background-color: #136598; color: #f6f6f6">
      <div style="font-weight: bold; margin-top: -2px">{{title}}
        <label v-if="height < 40" style="margin-left: 3px">({{num}})</label>
      </div>
      <div v-if="height >= 40" style="font-size: 12px">
        <div v-if="waitNum === undefined">
          <label style="color: #f6f6f6; font-weight: bold; font-size: 13px">{{num}}</label>
        </div>
        <div v-else>
          <label style="margin-right: 10px;">在线</label>
          <label style="font-weight: bold; font-size: 13px">{{num}}</label>
          <label style="margin: 0 10px 0 12px;">等待</label>
          <label style="font-weight: bold; font-size: 13px">{{waitNum}}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'WorkTitle',
    props: {
      title: {
        required: true,
        type: String
      },
      height: {
        required: true,
        type: Number
      },
      num: {
        required: true,
        type: Number
      },
      waitNum: Number
    },
    computed: {
      titleStyle () {
        return {
          height: this.height + 'px',
          textAlign: 'center'
        }
      }
    }
  }
</script>

<style scoped>

</style>
